import React, { Component, Fragment } from 'react';
import { closePrintSelector, openPrintWarning } from '../lib/functions';
import PrintMessage from './PrintMessage';

class PrintSelector extends Component {

     handlePrintClick = () => {
        const { qchecked, mschecked, erchecked, nchecked, allQuestions, allMarks, allExaminer, allNotes } = this.props
        const printSelection = () => {
            return allQuestions.concat(allMarks, allExaminer, allNotes).join("")
        } 
        
         if (qchecked === false && mschecked === false && erchecked === false && nchecked === false) {
            openPrintWarning()
        } else {
             document.getElementById("printOutputFrame").src =`https://app.doublestruck.eu/viewer/data/preview.php/?d=${this.props.docID}&t=${printSelection()}&p=1`;
         }
    }
   
    render() {
        return(
            <Fragment>
                <div id="print-selector" hidden>
                <PrintMessage />
                <div className="print-checkboxes">
                        <label key="question" hidden={this.props.showq === 1 ? false : true}>
                        <input className="print-input" name="question"
                            type="checkbox"
                            checked={this.props.qchecked}
                            onChange={this.props.handlePrintChange} />
                            Question
                    </label>
                        <label key="markscheme" hidden={this.props.showm === 1 ? false : true}>
                        <input className="print-input" name="markscheme"
                            type="checkbox"
                            checked={this.props.mschecked}
                            onChange={this.props.handlePrintChange} />
                            Mark Scheme
                    </label>
                        <label key="examinerreport" hidden={this.props.showe === 1 ? false : true}>
                        <input className="print-input" name="examinerreport"
                            type="checkbox"
                            checked={this.props.erchecked}
                            onChange={this.props.handlePrintChange} />
                            Examiner Remarks
                    </label>
                        <label key="notes" hidden={this.props.shown === 1 ? false : true}>
                        <input className="print-input" name="notes"
                            type="checkbox"
                            checked={this.props.nchecked}
                            onChange={this.props.handlePrintChange} />
                            Notes
                    </label>
                </div>
                    <div className="print-selector-print" onClick={this.handlePrintClick}>
                        <div className="menu-button">
                            <p>Print</p>
                        </div>
                        <div className="menu-button">
                            <p><i className="fa fa-print"></i></p>
                        </div>
                    </div>
                    <div className="menu-button print-cancel-button" onClick={closePrintSelector}>
                        <p className="menu-cancel">Cancel</p>
                    </div>
                </div>
            </Fragment>
        )

    }

}

export default PrintSelector;